/*
 * event.js
 * Written by: Connor Taylor
 *
 * Helper method for logging user events.
 */
import method from '../method';
/**
 * Logs a Piwik event. Provided as a convenience, identical to calling
 * `method(`trackEvent`, data)`. See [Piwik docs](https://piwik.org/docs/event-tracking/#tracking-events)
 * for info about what items to place in `data`.
 *
 * @param  {Array} data The Piwik event data
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * // `data` has [category, action, name, value]
 * event([`click`, `button`, `foobar`, 1]);
 */

var event = function event(data) {
  return method("trackEvent", data);
};
/** @component */


export default event;